import { render, staticRenderFns } from "./InformationComponent.vue?vue&type=template&id=42bd27ef&scoped=true"
import script from "./InformationComponent.vue?vue&type=script&lang=js"
export * from "./InformationComponent.vue?vue&type=script&lang=js"
import style0 from "./InformationComponent.vue?vue&type=style&index=0&id=42bd27ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd27ef",
  null
  
)

export default component.exports